/**
 * Notas de voz UDV — barrel export.
 */
export { DEVICE_TYPES, VOICE_NOTE_FILENAME, VOICE_MP3_BITRATE, VOICE_INGEST_PATH } from './types'
export { AudioRecorder, isMediaRecorderSupported, canPauseMediaRecorder } from './AudioRecorder'
export { encodeMp3, encodeMp3Sync } from './encodeMp3'
export { loadLamejs, resolveLameScriptUrl } from './loadLamejs'
export { shareVoiceNote } from './shareVoiceNote'
export {
  resolveDeviceType,
  probeDeviceCapability,
  resolveWhisperModel,
  pickWhisperModelTier,
  getWhisperModelOverride,
  whisperModelIdForTier,
  WHISPER_MODEL_IDS,
} from './deviceCapability'
export {
  LiveSpeechSession,
  canRunLiveSpeech,
  isLiveSpeechSupported,
  isLiveSpeechEnabled,
  getLiveSpeechBlockReason,
  isSecureLiveSpeechContext,
} from './liveSpeech'
export {
  LiveLocalSttSession,
  canRunLiveLocalStt,
  isLiveLocalEnabled,
  preloadLiveLocalStt,
  transcribeChunkViaGateway,
} from './liveLocalStt'
export { PcmCaptureSession, isPcmCaptureSupported } from './pcmCapture'
export { VadSession, simulateVadSegmentation } from './vadSession'
export {
  LocalAgreementBuffer,
  mergeChunkAgreement,
  normalizeAgreementText,
} from './localAgreement'
export {
  getSttPrefsSnapshot,
  suggestSttModels,
  setFinalModelChoice,
  setLiveModelChoice,
  setWebSpeechPref,
  setShowTimestampsPref,
  getShowTimestampsPref,
  getWebSpeechPref,
  getFinalModelChoice,
  getLiveModelChoice,
  isChromeLikeSpeechBrowser,
  WHISPER_MODEL_META,
  resolveLiveModelFromPrefs,
  getTranscribeDesktopPref,
  setTranscribeDesktopPref,
  getTranscribeMobilePref,
  setTranscribeMobilePref,
  isMobileVoiceDevice,
  isTranscriptionEnabledForDevice,
  canTranscribeVoiceNotes,
} from './sttPrefs'
export {
  buildHybridTranscript,
  tokenizeLive,
  normalizeToken,
} from './alignTranscript'
export { AudioSpatialMapper, audioSpatialMapper } from './audioSpatialMapper'
export { ingestVoiceNote, isVoiceIngestEnabled } from './voiceNotesIngest'
export {
  saveVoiceNote,
  listVoiceNotesForStudy,
  deleteVoiceNote,
  voiceNoteRowToUi,
  revokeVoiceNoteObjectUrls,
  openVoiceNotesDb,
  updateVoiceNoteTranscript,
} from './voiceNotesStore'
export {
  buildVoiceNoteShareText,
  formatStudyDateForShare,
} from './voiceNoteShareText'
export {
  transcribeLocal,
  canRunLocalWhisper,
  isLocalWhisperEnabled,
  getLocalWhisperSkipReason,
  decodeAudioBlobToMonoPcm,
  preloadWhisper,
  preloadWhisperModels,
  transcribeChunk,
  resolveLiveWhisperModel,
} from './transcribeLocal'
export {
  getSttRuntimeSnapshot,
  subscribeSttRuntime,
  updateSttRuntime,
  scheduleNpuProbe,
  probeWebnnNpuAvailable,
} from './sttRuntime'
export {
  touchLruOrder,
  evictLruIfNeeded,
  mapWhisperProgressPhase,
  mapSttProgressToUi,
  formatWhisperModelShort,
} from './whisperModelCache'
